<script setup>

</script>

<template>
    <div style="background-color: var(--brand-bg)">
      <div class="text-404 d-flex justify-content-center align-items-center">404</div>
    </div>
    <div class="d-flex flex-column align-items-center py-4">
        <div class="not-found-text">Page Not Found</div>
        <div class="not-found-paragraph">The page you are looking for does not exist.</div>
    </div>
</template>

<style scoped>
.not-found-text {
  font-weight: 500;
  font-size: 2.5rem;
}

.text-404 {
  font-family: 'Roboto', sans-serif;
  font-weight: 800;
  font-size: 8rem;
  letter-spacing: 1.2rem;
  color: white;
}

.not-found-paragraph,.not-found-text { font-family: 'Montserrat', sans-serif; }
</style>